import { render } from "./FleetModelData.vue?vue&type=template&id=2fa3a6fd"
import script from "./FleetModelData.vue?vue&type=script&lang=js"
export * from "./FleetModelData.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__